import React, { useEffect, useState } from "react";
// import { IArticle } from "../order/orderDetail";
import SalesArticleItem from "./salesArticleItem";
import { useSelectedArticleStore } from "../../store/store";
import { Article } from "../../api/order/generated/src";

interface ISalesArticleListProps {
    articles: Article[];
    defaultSelected?: string;
}

const SalesArticleList = (props:ISalesArticleListProps) => {

    const { articles, defaultSelected } = props;

    const [ selectedId, setSelectedId ] = useState<string>(defaultSelected || "");

    const selectedArticle = useSelectedArticleStore(state => state.article);
    const setSelectedArticle = useSelectedArticleStore(state => state.updateSelected);

    useEffect(() => {
        if(defaultSelected){
            setSelectedId(defaultSelected);
        }
        
    }, [defaultSelected]);

    const onSelect = (id:string) => {
        setSelectedId(id);

        setSelectedArticle(id, "");
    };


    const renderItems = () => {
        return props.articles?.map((item, index) => {
            return (
                <SalesArticleItem 
                    key={index}                
                    article={item}

                    onSelect={onSelect}

                    selected={item.id === selectedId}
                />
            );
        })
    }


    return (

        <div className="p-4 space-y-3">
            {props.articles && props.articles?.length > 0 && renderItems()}
        </div>

        
    )
};

export default SalesArticleList;
